function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import fonts from '../theme/fonts.js';
import colors from '../theme/colors.js';
import { useTheme } from '@mui/system';
import TableCell from "@mui/material/TableCell/TableCell";

/**
 * 
 * @param {*} props 
 * @returns 
 */
const StyledTableCell = props => {
  const theme = useTheme();
  const style = {
    "&.MuiTableCell-body": {
      color: colors.mainTextGrey,
      fontFamily: fonts.type.base,
      fontSize: fonts.size.medium
    },
    "&.MuiTableCell-head": {
      color: theme.palette.whitelabel.buttonTextColor,
      fontFamily: fonts.type.heading,
      fontSize: fonts.size.medium
    },
    "&.MuiTableCell-root": {
      borderBottom: 'none',
      padding: '4px 2vw 4px 1.96vw',
      whiteSpace: 'nowrap'
    },
    ...props.style
  };
  return /*#__PURE__*/React.createElement(TableCell, _extends({
    sx: style
  }, props), props.children);
};
export default StyledTableCell;